import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowDown, FaArrowUp, FaGripVertical } from "react-icons/fa";
import { PROPOSAL_SET_VALUES } from "../../store/constants/proposalConstants";
import {
  SECTION_ORDER_LABELS,
  getDefaultSectionOrder,
  normalizeSectionOrder,
  reorderList,
} from "../../utils/constants/proposalSectionOrder";

const ArrangeSections = () => {
  const dispatch = useDispatch();
  const sectionOrder = normalizeSectionOrder(
    useSelector((state) => state.proposalValues.section_order)
  );

  const updateOrder = (nextOrder) => {
    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: { section_order: nextOrder },
    });
  };

  const move = (index, direction) => {
    const endIndex = index + direction;
    if (endIndex < 0 || endIndex >= sectionOrder.length) {
      return;
    }
    updateOrder(reorderList(sectionOrder, index, endIndex));
  };

  return (
    <div>
      <p className="text-muted mb-3" style={{ textTransform: "none" }}>
        Change the order of any section on the proposal. You can also drag the
        grip handles on the preview.
      </p>
      {sectionOrder.map((id, index) => (
        <div key={id} className="proposal-arrange-item">
          <span className="flex-grow-1">{SECTION_ORDER_LABELS[id] || id}</span>
          <Button
            type="button"
            variant="outline-secondary"
            size="sm"
            className="ms-1 py-0 px-2"
            disabled={index === 0}
            onClick={() => move(index, -1)}
            aria-label={`Move ${SECTION_ORDER_LABELS[id]} up`}
          >
            <FaArrowUp />
          </Button>
          <Button
            type="button"
            variant="outline-secondary"
            size="sm"
            className="ms-1 py-0 px-2"
            disabled={index === sectionOrder.length - 1}
            onClick={() => move(index, 1)}
            aria-label={`Move ${SECTION_ORDER_LABELS[id]} down`}
          >
            <FaArrowDown />
          </Button>
        </div>
      ))}
      <Button
        type="button"
        variant="outline-secondary"
        size="sm"
        className="mt-2"
        onClick={() => updateOrder(getDefaultSectionOrder())}
      >
        Reset section order
      </Button>
    </div>
  );
};

export default ArrangeSections;
